<template>
  <svg id="7dd09a4d-2b74-438e-986e-0efea9b9300a" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink" width="734" height="764.5" viewBox="0 0 734 764.5">
    <defs>
      <linearGradient id="de77dbfb-dd49-4fbc-923c-7946454dd32b" x1="366.37" y1="536.32" x2="608.5" y2="536.32"
                      gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="gray" stop-opacity="0.25"/>
        <stop offset="0.54" stop-color="gray" stop-opacity="0.12"/>
        <stop offset="1" stop-color="gray" stop-opacity="0.1"/>
      </linearGradient>
      <linearGradient id="6bfe4e4d-6140-4dd1-aeb6-1c24ce52378d" x1="124.23" y1="536.32" x2="366.37" y2="536.32"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="eefef033-b9dd-454d-be9c-2768628c2c1b" x1="366.37" y1="285.31" x2="734" y2="285.31"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="56c8a114-3a82-4d1f-807f-287066e4913e" x1="0" y1="285.31" x2="366.37" y2="285.31"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="d46a1a66-2ac6-4fbc-9777-fd8606b62c04" x1="276.64" y1="421.19" x2="276.64" y2="255.38"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="81b747dc-c51a-4f4d-a150-34ccfb0c2b19" x1="188.97" y1="337.56" x2="364.55" y2="337.56"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="94dacd35-ade1-481d-ab7d-e71442837947" x1="202.5" y1="296.63" x2="232.11" y2="296.63"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="5f9514a3-5a07-41ce-8d35-51c596d713f8" x1="240.99" y1="284.79" x2="358.7" y2="284.79"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="5f23502f-63c8-483a-bbd9-acad51c7384b" x1="240.99" y1="293.67" x2="358.7" y2="293.67"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="1d6905ae-9130-4997-8264-fbb8cedb035a" x1="199.54" y1="325.92" x2="358.7" y2="325.92"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="41900377-e2ec-4e09-a282-5ca05bd60f31" x1="199.54" y1="334.8" x2="358.7" y2="334.8"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="dd8a4518-18b3-4e66-a30f-5d540a356d99" x1="199.54" y1="346.64" x2="358.7" y2="346.64"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="73297694-c0f6-49f7-84f0-ecf1ccd19cc8" x1="199.54" y1="355.53" x2="291.33" y2="355.53"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="493ae8f5-00a4-414a-a514-466a18e555de" x1="199.54" y1="367.34" x2="358.7" y2="367.34"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="3b1e923e-cefa-4350-8e60-09975381dcc2" x1="199.54" y1="376.22" x2="358.7" y2="376.22"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="0a8186d7-b2d8-4c25-b395-9cdd58a3b32d" x1="199.54" y1="388.07" x2="358.7" y2="388.07"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="80621535-6eff-45be-9aff-a177b1fc6ef5" x1="199.54" y1="396.95" x2="291.33" y2="396.95"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="dadd1f9f-4435-4897-9b35-9a7b7fdf052b" x1="303.76" y1="459.51" x2="303.76" y2="293.69"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="f16d3271-277e-4f15-bb07-00d21db963c6" x1="216.09" y1="375.88" x2="391.67" y2="375.88"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="6844f77f-b831-40d5-baa2-4d635352d65d" x1="229.62" y1="334.95" x2="259.23" y2="334.95"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="de24e734-f614-4284-b96a-2aa86e10747c" x1="268.12" y1="323.11" x2="385.83" y2="323.11"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="a5efd049-cacb-4880-98c4-916efb717ead" x1="268.12" y1="331.99" x2="385.83" y2="331.99"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="7e130a40-8f7a-4850-a2d6-6e0275737139" x1="226.66" y1="364.23" x2="385.83" y2="364.23"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="2749f835-9066-4c26-94de-8091e8f0d23b" x1="226.66" y1="373.12" x2="385.83" y2="373.12"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="83d2a205-1aab-4c1f-9a0d-e371e1497593" x1="226.66" y1="384.96" x2="385.83" y2="384.96"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="eaa6c3f5-6275-43ae-b3c2-02cbd6aead80" x1="226.66" y1="393.84" x2="318.45" y2="393.84"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="e1588a1d-b1ef-45da-83e8-d054f8a4e057" x1="226.66" y1="405.66" x2="385.83" y2="405.66"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="34a60174-261b-4ce6-8479-6deff5e9df2e" x1="226.66" y1="414.54" x2="385.83" y2="414.54"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="b1d4060a-bab6-41d9-9d3f-50faf13ce905" x1="226.66" y1="426.39" x2="385.83" y2="426.39"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="001da48e-f69d-4ab6-b1e5-b6877c600ca3" x1="226.66" y1="435.27" x2="318.45" y2="435.27"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="a9c4be37-9b27-4af0-b082-7a197d7b08af" x1="396.27" y1="498.11" x2="396.27" y2="315.15"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="1be8f728-2df0-4ca7-b72e-42c383ba6409" x1="323.2" y1="406.08" x2="470.82" y2="406.08"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="2c239d92-4298-42ac-b5f5-112261fb3719" x1="630.01" y1="435.54" x2="630.01" y2="409.41"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="b25a2850-8713-435e-a7f6-77c24068e559" x1="379.34" y1="356.75" x2="414.68" y2="356.75"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="098fbc02-4549-4943-b845-c35e13d002ec" x1="389.65" y1="345.34" x2="404.37" y2="345.34"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="42d5ad37-1f95-4efe-a9d6-9d5a7598317f" x1="345.29" y1="397.51" x2="449.1" y2="397.51"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="60652df1-b02f-405a-bafe-63f1323ca3b9" x1="345.29" y1="426.59" x2="449.1" y2="426.59"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="d60c104b-effa-4916-ba15-d56398cc91aa" x1="345.29" y1="434.32" x2="449.1" y2="434.32"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="ba8a67f6-dfe8-450d-b63e-7f0d0a91ef94" x1="345.29" y1="418.86" x2="389.1" y2="418.86"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="78ba6fe6-ecca-4e26-a377-427f9aaa9d9c" x1="416.34" y1="418.86" x2="449.1" y2="418.86"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="1435728f-56d7-4408-a8a2-001738c99643" x1="381.73" y1="452.36" x2="414.5" y2="452.36"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="9b7fa617-5070-4448-ba88-12c8e3ef9a97" x1="124.23" y1="565.47" x2="366.37" y2="565.47"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="070ec920-a668-4755-a0ad-3a8615a89315" x1="366.37" y1="565.47" x2="608.5" y2="565.47"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="e36d19af-3b30-4690-9806-5999beea7781" x1="512.15" y1="631.39" x2="608.5" y2="631.39"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="a6dd6711-50c1-4fdb-98f5-9ce3faa6868a" x1="517.49" y1="407.03" x2="517.49" y2="338.42"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="c3285259-7532-4ca4-be71-649fbde17c17" x1="482.9" y1="372.87" x2="552.07" y2="372.87"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="a29959c1-757f-4596-a472-135c84a27060" x1="750.49" y1="435.86" x2="750.49" y2="415.97"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="d4e4a16f-6e37-4db9-afc4-c764cb698323" x1="504.04" y1="359.71" x2="530.93" y2="359.71"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="cff56feb-0464-47d9-bfaf-95cdd3d9140f" x1="511.89" y1="351.03" x2="523.09" y2="351.03"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="03628828-f4ed-4a34-b456-49742169550b" x1="505.58" y1="380.71" x2="530.51" y2="380.71"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="563972f9-7c15-4736-8e1d-5831e19f738d" x1="496.2" y1="386.87" x2="538.77" y2="386.87"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="ac84c3f4-4913-47be-bf79-f44b0f4db4c8" x1="358.76" y1="204.69" x2="358.76" y2="128.69"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="08e6e94c-7f78-4a4a-b5ca-eacc99124954" x1="313.57" y1="166.78" x2="403.76" y2="166.78"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="5d8bf870-f7e1-4226-8bb2-e6c031939852" x1="313.57" y1="138.3" x2="403.76" y2="138.3"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="ca57a38f-5e0b-4f9a-ad35-d20a6a3fb589" x1="320.76" y1="157.17" x2="396.57" y2="157.17"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="1fd9aa29-bfa0-42ec-baa0-a47f4919731f" x1="320.76" y1="170.73" x2="376.09" y2="170.73"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="2b0d4ee5-bed4-41f8-93bf-55bbaa1359c2" x1="320.76" y1="176.3" x2="356.69" y2="176.3"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="ffea16a4-8b84-4b92-9000-f48bb1ea4454" x1="320.76" y1="181.87" x2="368.19" y2="181.87"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="bd2a8e8b-f3e8-4ae2-849a-acfa94ff2f68" x1="320.76" y1="187.44" x2="376.09" y2="187.44"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="f06efa35-a8e5-4b8b-afbe-7609fb33c535" x1="320.76" y1="193.01" x2="339.26" y2="193.01"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="b384c48b-fa09-4d02-bdd3-cc00491ed01d" x1="505.86" y1="279.95" x2="505.86" y2="185.76"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="5e00f217-30a6-42ff-b3ae-1a90f6b4187c" x1="449.86" y1="232.96" x2="561.64" y2="232.96"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="dc2aebd1-2b83-4119-bcc5-a741f826754f" x1="449.86" y1="197.67" x2="561.64" y2="197.67"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="93231171-c5fd-4b16-9e58-5bf8089a9216" x1="458.76" y1="221.05" x2="552.73" y2="221.05"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="50b8a9d8-eeba-4f66-80ff-241f1361769d" x1="458.76" y1="237.86" x2="527.35" y2="237.86"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="1c46a2fd-722a-4782-991f-2753aa584a85" x1="458.76" y1="244.77" x2="503.3" y2="244.77"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="20746c70-8f38-4111-a8e7-6be16dcdc432" x1="458.76" y1="251.67" x2="517.55" y2="251.67"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="ff2c3201-2e6a-4c49-9262-7d1610fa9938" x1="458.76" y1="258.57" x2="527.35" y2="258.57"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="f77a8c52-f808-4319-bd14-9cea9a000094" x1="458.76" y1="265.48" x2="481.7" y2="265.48"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="fc3b52e5-7958-4225-afa3-e6f186f3a800" x1="463.66" y1="220.94" x2="490.38" y2="220.94"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="2b5a7ca0-2cf9-4df0-8cdd-e53d9708a5ec" x1="121.07" y1="472.93" x2="365.73" y2="472.93"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="90935925-bac4-44a4-bec6-4c83fa48424d" x1="365.73" y1="472.93" x2="610.4" y2="472.93"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="f90ef38d-8fba-46a7-8e54-2d901dfd8f20" x1="0" y1="448.21" x2="366.37" y2="448.21"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="7f322de3-7e3f-4ca5-a3a0-2f913675712e" x1="366.37" y1="448.21" x2="734" y2="448.21"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="7e9b6443-5111-46ce-82ab-312f92c279a9" x1="279.92" y1="417.64" x2="279.92" y2="253.24"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="0bd401ed-ef45-4e9e-bf5f-b77781a1e2b2" x1="306.82" y1="455.63" x2="306.82" y2="291.23"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="8c2d82fb-4f28-4e85-a5ca-7392731b2ba5" x1="398.54" y1="493.9" x2="398.54" y2="312.51"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="5d661687-e38a-43c0-8ba0-d38908ccc19f" x1="632.27" y1="432.45" x2="632.27" y2="406.53"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="e62c516b-7ef4-49fd-a0a5-f3f48af03dcb" x1="518.71" y1="403.6" x2="518.71" y2="335.58"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="6e0711fe-dd5e-4be2-836c-3534ecd56ee9" x1="751.71" y1="432.76" x2="751.71" y2="413.05"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="c910eb88-40c3-4f47-be10-2fca2f669ad6" x1="450.84" y1="68.02" x2="450.84" y2="0"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="81ab2f40-7513-4f79-907c-194f7c944fd5" x1="683.84" y1="97.18" x2="683.84" y2="77.47"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="ced5db71-211d-4559-8944-028d2e60ece5" x1="361.34" y1="202.99" x2="361.34" y2="127.64"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
      <linearGradient id="4adf524d-df88-48e8-970a-1ad7028c73c0" x1="507.18" y1="277.61" x2="507.18" y2="184.22"
                      xlink:href="#de77dbfb-dd49-4fbc-923c-7946454dd32b"/>
    </defs>
    <title>collecting</title>
    <g opacity="0.7">
      <polygon points="608.5 366.44 366.37 308.13 366.37 764.5 608.5 701.12 608.5 366.44"
               fill="url(#de77dbfb-dd49-4fbc-923c-7946454dd32b)"/>
      <g opacity="0.1">
        <polygon points="608.5 366.44 366.37 308.13 366.37 764.5 608.5 701.12 608.5 366.44"
                 fill="url(#de77dbfb-dd49-4fbc-923c-7946454dd32b)"/>
      </g>
      <polygon points="124.23 366.44 366.37 308.13 366.37 764.5 124.23 702.38 124.23 366.44"
               fill="url(#6bfe4e4d-6140-4dd1-aeb6-1c24ce52378d)"/>
      <g opacity="0.17">
        <polygon points="124.23 366.44 366.37 308.13 366.37 764.5 124.23 702.38 124.23 366.44"
                 fill="url(#6bfe4e4d-6140-4dd1-aeb6-1c24ce52378d)"/>
      </g>
      <polygon points="366.37 308.13 491.87 204.18 734 266.3 608.5 366.44 366.37 308.13"
               fill="url(#eefef033-b9dd-454d-be9c-2768628c2c1b)"/>
      <polygon points="0 267.56 124.23 366.44 366.37 308.13 243.4 204.18 0 267.56"
               fill="url(#56c8a114-3a82-4d1f-807f-287066e4913e)"/>
      <g opacity="0.05">
        <polygon points="0 267.56 124.23 366.44 366.37 308.13 243.4 204.18 0 267.56"
                 fill="url(#56c8a114-3a82-4d1f-807f-287066e4913e)"/>
      </g>
      <g opacity="0.5">
        <rect x="186.78" y="255.38" width="179.72" height="165.82" rx="4.5" ry="4.5"
              fill="url(#d46a1a66-2ac6-4fbc-9777-fd8606b62c04)"/>
      </g>
      <rect x="188.97" y="256.66" width="175.58" height="161.8" rx="4.5" ry="4.5"
            fill="url(#81b747dc-c51a-4f4d-a150-34ccfb0c2b19)"/>
      <rect x="202.5" y="283.31" width="29.61" height="26.65" rx="4.5" ry="4.5"
            fill="url(#94dacd35-ade1-481d-ab7d-e71442837947)"/>
      <rect x="240.99" y="283.31" width="117.71" height="2.96" rx="0.8" ry="0.8"
            fill="url(#5f9514a3-5a07-41ce-8d35-51c596d713f8)"/>
      <rect x="240.99" y="292.19" width="117.71" height="2.96" rx="0.8" ry="0.8"
            fill="url(#5f23502f-63c8-483a-bbd9-acad51c7384b)"/>
      <rect x="199.54" y="324.44" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#1d6905ae-9130-4997-8264-fbb8cedb035a)"/>
      <rect x="199.54" y="333.32" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#41900377-e2ec-4e09-a282-5ca05bd60f31)"/>
      <rect x="199.54" y="345.16" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#dd8a4518-18b3-4e66-a30f-5d540a356d99)"/>
      <rect x="199.54" y="354.05" width="91.79" height="2.96" rx="0.8" ry="0.8"
            fill="url(#73297694-c0f6-49f7-84f0-ecf1ccd19cc8)"/>
      <rect x="199.54" y="365.86" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#493ae8f5-00a4-414a-a514-466a18e555de)"/>
      <rect x="199.54" y="374.74" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#3b1e923e-cefa-4350-8e60-09975381dcc2)"/>
      <rect x="199.54" y="386.59" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#0a8186d7-b2d8-4c25-b395-9cdd58a3b32d)"/>
      <rect x="199.54" y="395.47" width="91.79" height="2.96" rx="0.8" ry="0.8"
            fill="url(#80621535-6eff-45be-9aff-a177b1fc6ef5)"/>
      <g opacity="0.5">
        <rect x="213.9" y="293.69" width="179.72" height="165.82" rx="4.5" ry="4.5"
              fill="url(#dadd1f9f-4435-4897-9b35-9a7b7fdf052b)"/>
      </g>
      <rect x="216.09" y="294.98" width="175.58" height="161.8" rx="4.5" ry="4.5"
            fill="url(#f16d3271-277e-4f15-bb07-00d21db963c6)"/>
      <rect x="229.62" y="321.63" width="29.61" height="26.65" rx="4.5" ry="4.5"
            fill="url(#6844f77f-b831-40d5-baa2-4d635352d65d)"/>
      <rect x="268.12" y="321.63" width="117.71" height="2.96" rx="0.8" ry="0.8"
            fill="url(#de24e734-f614-4284-b96a-2aa86e10747c)"/>
      <rect x="268.12" y="330.51" width="117.71" height="2.96" rx="0.8" ry="0.8"
            fill="url(#a5efd049-cacb-4880-98c4-916efb717ead)"/>
      <rect x="226.66" y="362.75" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#7e130a40-8f7a-4850-a2d6-6e0275737139)"/>
      <rect x="226.66" y="371.64" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#2749f835-9066-4c26-94de-8091e8f0d23b)"/>
      <rect x="226.66" y="383.48" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#83d2a205-1aab-4c1f-9a0d-e371e1497593)"/>
      <rect x="226.66" y="392.36" width="91.79" height="2.96" rx="0.8" ry="0.8"
            fill="url(#eaa6c3f5-6275-43ae-b3c2-02cbd6aead80)"/>
      <rect x="226.66" y="404.18" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#e1588a1d-b1ef-45da-83e8-d054f8a4e057)"/>
      <rect x="226.66" y="413.06" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#34a60174-261b-4ce6-8479-6deff5e9df2e)"/>
      <rect x="226.66" y="424.91" width="159.16" height="2.96" rx="0.8" ry="0.8"
            fill="url(#b1d4060a-bab6-41d9-9d3f-50faf13ce905)"/>
      <rect x="226.66" y="433.79" width="91.79" height="2.96" rx="0.8" ry="0.8"
            fill="url(#001da48e-f69d-4ab6-b1e5-b6877c600ca3)"/>
      <g opacity="0.5">
        <rect x="318.41" y="315.15" width="155.72" height="182.96" fill="url(#a9c4be37-9b27-4af0-b082-7a197d7b08af)"/>
      </g>
      <rect x="323.2" y="318.1" width="147.62" height="175.97" fill="url(#1be8f728-2df0-4ca7-b72e-42c383ba6409)"/>
      <g opacity="0.5">
        <path d="M638.05,413.83v-4.42H622v4.42H610.71v21.71h38.6V413.83ZM624,411H636v2.81H624Z"
              transform="translate(-233 -67.75)" fill="url(#2c239d92-4298-42ac-b5f5-112261fb3719)"/>
      </g>
      <rect x="379.34" y="346.81" width="35.34" height="19.88" fill="url(#b25a2850-8713-435e-a7f6-77c24068e559)"/>
      <polygon
        points="389.65 342.76 389.65 347.92 391.49 347.92 391.49 344.24 402.53 344.24 402.53 347.92 404.37 347.92 404.37 342.76 389.65 342.76"
        fill="url(#098fbc02-4549-4943-b845-c35e13d002ec)"/>
      <rect x="345.29" y="395.3" width="103.81" height="4.42" fill="url(#42d5ad37-1f95-4efe-a9d6-9d5a7598317f)"/>
      <rect x="345.29" y="424.38" width="103.81" height="4.42" fill="url(#60652df1-b02f-405a-bafe-63f1323ca3b9)"/>
      <rect x="345.29" y="432.11" width="103.81" height="4.42" fill="url(#d60c104b-effa-4916-ba15-d56398cc91aa)"/>
      <rect x="345.29" y="416.65" width="43.81" height="4.42" fill="url(#ba8a67f6-dfe8-450d-b63e-7f0d0a91ef94)"/>
      <g opacity="0.6">
        <rect x="416.34" y="416.65" width="32.76" height="4.42" fill="url(#78ba6fe6-ecca-4e26-a377-427f9aaa9d9c)"/>
      </g>
      <rect x="381.73" y="450.15" width="32.76" height="4.42" fill="url(#1435728f-56d7-4408-a8a2-001738c99643)"/>
      <polygon points="124.23 366.44 124.23 702.38 366.37 764.5 366.37 431.1 124.23 366.44"
               fill="url(#9b7fa617-5070-4448-ba88-12c8e3ef9a97)"/>
      <polygon points="608.5 701.12 366.37 764.5 366.37 431.1 608.5 366.44 608.5 701.12"
               fill="url(#070ec920-a668-4755-a0ad-3a8615a89315)"/>
      <g opacity="0.07">
        <polygon points="608.5 701.12 366.37 764.5 366.37 431.1 608.5 366.44 608.5 701.12"
                 fill="url(#070ec920-a668-4755-a0ad-3a8615a89315)"/>
      </g>
      <g opacity="0.07">
        <polygon points="512.15 589.56 512.15 699.85 608.5 673.23 608.5 562.94 512.15 589.56"
                 fill="url(#e36d19af-3b30-4690-9806-5999beea7781)"/>
      </g>
      <rect x="481.78" y="338.42" width="71.41" height="68.61" fill="url(#a6dd6711-50c1-4fdb-98f5-9ce3faa6868a)"/>
      <rect x="482.9" y="340.1" width="69.17" height="65.53" fill="url(#c3285259-7532-4ca4-be71-649fbde17c17)"/>
      <g opacity="0.5">
        <path d="M756.6,419.34V416H744.37v3.36H735.8v16.52h29.37V419.34ZM745.9,417.2h9.18v2.14H745.9Z"
              transform="translate(-233 -67.75)" fill="url(#a29959c1-757f-4596-a472-135c84a27060)"/>
      </g>
      <g opacity="0.6">
        <rect x="504.04" y="352.15" width="26.88" height="15.12" fill="url(#d4e4a16f-6e37-4db9-afc4-c764cb698323)"/>
      </g>
      <g opacity="0.6">
        <polygon
          points="511.88 349.06 511.88 352.99 513.29 352.99 513.29 350.19 521.69 350.19 521.69 352.99 523.09 352.99 523.09 349.06 511.88 349.06"
          fill="url(#cff56feb-0464-47d9-bfaf-95cdd3d9140f)"/>
      </g>
      <g opacity="0.6">
        <rect x="505.58" y="379.03" width="24.92" height="3.36" fill="url(#03628828-f4ed-4a34-b456-49742169550b)"/>
      </g>
      <rect x="496.2" y="385.19" width="42.57" height="3.36" fill="url(#563972f9-7c15-4736-8e1d-5831e19f738d)"/>
      <g opacity="0.5">
        <rect x="312.49" y="128.69" width="92.52" height="76" fill="url(#ac84c3f4-4913-47be-bf79-f44b0f4db4c8)"/>
      </g>
      <rect x="313.57" y="130.13" width="90.19" height="73.3" fill="url(#08e6e94c-7f78-4a4a-b5ca-eacc99124954)"/>
      <rect x="313.57" y="130.13" width="90.19" height="16.35" fill="url(#5d8bf870-f7e1-4226-8bb2-e6c031939852)"/>
      <g opacity="0.1">
        <rect x="313.57" y="130.13" width="90.19" height="16.35" fill="url(#5d8bf870-f7e1-4226-8bb2-e6c031939852)"/>
      </g>
      <rect x="320.76" y="152.41" width="75.82" height="9.52" fill="url(#ca57a38f-5e0b-4f9a-ad35-d20a6a3fb589)"/>
      <rect x="320.76" y="169.12" width="55.34" height="3.23" fill="url(#1fd9aa29-bfa0-42ec-baa0-a47f4919731f)"/>
      <rect x="320.76" y="174.69" width="35.93" height="3.23" fill="url(#2b0d4ee5-bed4-41f8-93bf-55bbaa1359c2)"/>
      <rect x="320.76" y="180.26" width="47.43" height="3.23" fill="url(#ffea16a4-8b84-4b92-9000-f48bb1ea4454)"/>
      <rect x="320.76" y="185.82" width="55.34" height="3.23" fill="url(#bd2a8e8b-f3e8-4ae2-849a-acfa94ff2f68)"/>
      <rect x="320.76" y="191.39" width="18.5" height="3.23" fill="url(#f06efa35-a8e5-4b8b-afbe-7609fb33c535)"/>
      <g opacity="0.5">
        <rect x="448.52" y="185.76" width="114.68" height="94.19" fill="url(#b384c48b-fa09-4d02-bdd3-cc00491ed01d)"/>
      </g>
      <rect x="449.86" y="187.54" width="111.79" height="90.85" fill="url(#5e00f217-30a6-42ff-b3ae-1a90f6b4187c)"/>
      <rect x="449.86" y="187.54" width="111.79" height="20.26" fill="url(#dc2aebd1-2b83-4119-bcc5-a741f826754f)"/>
      <rect x="458.76" y="215.15" width="93.97" height="11.8" fill="url(#93231171-c5fd-4b16-9e58-5bf8089a9216)"/>
      <rect x="458.76" y="235.86" width="68.59" height="4.01" fill="url(#50b8a9d8-eeba-4f66-80ff-241f1361769d)"/>
      <rect x="458.76" y="242.76" width="44.54" height="4.01" fill="url(#1c46a2fd-722a-4782-991f-2753aa584a85)"/>
      <rect x="458.76" y="249.67" width="58.79" height="4.01" fill="url(#20746c70-8f38-4111-a8e7-6be16dcdc432)"/>
      <rect x="458.76" y="256.57" width="68.59" height="4.01" fill="url(#ff2c3201-2e6a-4c49-9262-7d1610fa9938)"/>
      <rect x="458.76" y="263.47" width="22.94" height="4.01" fill="url(#f77a8c52-f808-4319-bd14-9cea9a000094)"/>
      <rect x="463.66" y="219.16" width="26.72" height="3.56" fill="url(#fc3b52e5-7958-4225-afa3-e6f186f3a800)"/>
      <g opacity="0.1">
        <polygon points="121.07 540.75 256.71 574.98 365.73 486.24 365.73 431.73 123.6 370.88 121.07 540.75"
                 fill="url(#2b5a7ca0-2cf9-4df0-8cdd-e53d9708a5ec)"/>
      </g>
      <g opacity="0.1">
        <polygon points="610.4 540.75 474.75 574.98 365.73 486.24 365.73 431.73 607.86 370.88 610.4 540.75"
                 fill="url(#90935925-bac4-44a4-bec6-4c83fa48424d)"/>
      </g>
      <polygon points="124.23 366.44 0 469.13 242.13 529.98 366.37 431.1 124.23 366.44"
               fill="url(#f90ef38d-8fba-46a7-8e54-2d901dfd8f20)"/>
      <polygon points="608.5 366.44 734 469.13 493.14 529.98 366.37 431.1 608.5 366.44"
               fill="url(#7f322de3-7e3f-4ca5-a3a0-2f913675712e)"/>
      <g opacity="0.07">
        <polygon points="608.5 366.44 734 469.13 493.14 529.98 366.37 431.1 608.5 366.44"
                 fill="url(#7f322de3-7e3f-4ca5-a3a0-2f913675712e)"/>
      </g>
    </g>
    <polygon points="608.94 363.36 368.88 305.54 368.88 758.01 608.94 695.17 608.94 363.36" fill="#535461"/>
    <polygon points="608.94 363.36 368.88 305.54 368.88 758.01 608.94 695.17 608.94 363.36" opacity="0.1"/>
    <polygon points="128.83 363.36 368.88 305.54 368.88 758.01 128.83 696.42 128.83 363.36" fill="#535461"/>
    <polygon points="128.83 361.36 368.88 303.54 368.88 758.01 128.83 696.42 128.83 361.36" opacity="0.17"/>
    <polygon points="366.88 307.54 493.31 202.48 733.37 264.07 606.94 365.36 366.88 307.54" fill="#535461"/>
    <polygon points="7.66 267.32 130.83 365.36 370.88 307.54 248.97 204.48 7.66 267.32" fill="#535461"/>
    <polygon points="5.66 265.32 131.83 365.36 371.88 307.54 246.97 202.48 5.66 265.32" opacity="0.05"/>
    <g opacity="0.5">
      <rect x="190.83" y="253.24" width="178.18" height="164.4" rx="4.5" ry="4.5"
            fill="url(#7e9b6443-5111-46ce-82ab-312f92c279a9)"/>
    </g>
    <rect x="193.01" y="254.52" width="174.07" height="160.41" rx="4.5" ry="4.5" fill="#f5f5f5"/>
    <rect x="206.42" y="280.94" width="29.36" height="26.42" rx="4.5" ry="4.5" fill="#4b5563"/>
    <rect x="244.59" y="280.94" width="116.7" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="244.59" y="289.74" width="116.7" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="203.49" y="321.71" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="203.49" y="330.52" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="203.49" y="342.26" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="203.49" y="351.07" width="91.01" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="203.49" y="362.78" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="203.49" y="371.59" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="203.49" y="383.33" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="203.49" y="392.14" width="91.01" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <g opacity="0.5">
      <rect x="217.72" y="291.23" width="178.18" height="164.4" rx="4.5" ry="4.5"
            fill="url(#0bd401ed-ef45-4e9e-bf5f-b77781a1e2b2)"/>
    </g>
    <rect x="219.9" y="292.51" width="174.07" height="160.41" rx="4.5" ry="4.5" fill="#fff"/>
    <rect x="233.31" y="318.93" width="29.36" height="26.42" rx="4.5" ry="4.5" fill="#4b5563"/>
    <rect x="271.48" y="318.93" width="116.7" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="271.48" y="327.73" width="116.7" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="230.38" y="359.7" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="230.38" y="368.51" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="230.38" y="380.25" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="230.38" y="389.06" width="91.01" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="230.38" y="400.77" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="230.38" y="409.58" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="230.38" y="421.32" width="157.8" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <rect x="230.38" y="430.13" width="91.01" height="2.94" rx="0.8" ry="0.8" fill="#e0e0e0"/>
    <g opacity="0.5">
      <rect x="321.34" y="312.51" width="154.39" height="181.39" fill="url(#8c2d82fb-4f28-4e85-a5ca-7392731b2ba5)"/>
    </g>
    <rect x="326.09" y="315.43" width="146.36" height="174.46" fill="#fff"/>
    <g opacity="0.5">
      <path d="M640.24,410.92v-4.39H624.29v4.39H613.13v21.53H651.4V410.92Zm-14-2.79h12v2.79h-12Z"
            transform="translate(-233 -67.75)" fill="url(#5d661687-e38a-43c0-8ba0-d38908ccc19f)"/>
    </g>
    <rect x="381.75" y="343.9" width="35.04" height="19.71" fill="#4b5563"/>
    <polygon
      points="391.97 339.88 391.97 344.99 393.79 344.99 393.79 341.34 404.74 341.34 404.74 344.99 406.57 344.99 406.57 339.88 391.97 339.88"
      fill="#4b5563"/>
    <rect x="347.99" y="391.97" width="102.92" height="4.38" fill="#e0e0e0"/>
    <rect x="347.99" y="420.8" width="102.92" height="4.38" fill="#e0e0e0"/>
    <rect x="347.99" y="428.47" width="102.92" height="4.38" fill="#e0e0e0"/>
    <rect x="347.99" y="413.14" width="43.43" height="4.38" fill="#e0e0e0"/>
    <rect x="418.43" y="413.14" width="32.48" height="4.38" fill="#3ad29f" opacity="0.6"/>
    <rect x="384.12" y="446.35" width="32.48" height="4.38" fill="#4b5563"/>
    <polygon points="128.83 363.36 128.83 696.42 368.88 758.01 372.12 427.46 128.83 363.36" fill="#535461"/>
    <polygon points="608.94 695.17 368.88 758.01 368.88 427.46 608.94 363.36 608.94 695.17" fill="#535461"/>
    <polygon points="608.94 695.17 368.88 758.01 368.88 427.46 608.94 363.36 608.94 695.17" opacity="0.07"/>
    <polygon points="513.42 584.57 513.42 693.91 608.94 667.52 608.94 558.17 513.42 584.57" opacity="0.07"/>
    <rect x="483.31" y="335.58" width="70.8" height="68.02" fill="url(#e62c516b-7ef4-49fd-a0a5-f3f48af03dcb)"/>
    <rect x="484.42" y="337.24" width="68.58" height="64.97" fill="#f5f5f5"/>
    <g opacity="0.5">
      <path d="M757.78,416.38V413H745.65v3.34h-8.49v16.38h29.11V416.38Zm-10.61-2.12h9.1v2.12h-9.1Z"
            transform="translate(-233 -67.75)" fill="url(#6e0711fe-dd5e-4be2-836c-3534ecd56ee9)"/>
    </g>
    <rect x="505.38" y="349.18" width="26.65" height="14.99" fill="#4b5563" opacity="0.6"/>
    <polygon
      points="513.16 346.13 513.16 350.02 514.55 350.02 514.55 347.24 522.88 347.24 522.88 350.02 524.26 350.02 524.26 346.13 513.16 346.13"
      fill="#4b5563" opacity="0.6"/>
    <g opacity="0.6">
      <rect x="506.91" y="375.84" width="24.71" height="3.33" fill="#4b5563"/>
    </g>
    <rect x="497.61" y="381.95" width="42.2" height="3.33" fill="#bdbdbd"/>
    <rect x="415.44" width="70.8" height="68.02" fill="url(#c910eb88-40c3-4f47-be10-2fca2f669ad6)"/>
    <rect x="416.55" y="1.67" width="68.58" height="64.97" fill="#f5f5f5"/>
    <g opacity="0.5">
      <path d="M689.91,80.8V77.47H677.78V80.8h-8.49V97.18H698.4V80.8Zm-10.61-2.12h9.1V80.8h-9.1Z"
            transform="translate(-233 -67.75)" fill="url(#81ab2f40-7513-4f79-907c-194f7c944fd5)"/>
    </g>
    <rect x="437.51" y="13.6" width="26.65" height="14.99" fill="#4b5563" opacity="0.6"/>
    <polygon
      points="445.29 10.55 445.29 14.44 446.68 14.44 446.68 11.66 455.01 11.66 455.01 14.44 456.39 14.44 456.39 10.55 445.29 10.55"
      fill="#4b5563" opacity="0.6"/>
    <g opacity="0.6">
      <rect x="439.04" y="40.26" width="24.71" height="3.33" fill="#4b5563"/>
    </g>
    <rect x="429.74" y="46.37" width="42.2" height="3.33" fill="#bdbdbd"/>
    <g opacity="0.5">
      <rect x="315.47" y="127.64" width="91.73" height="75.35" fill="url(#ced5db71-211d-4559-8944-028d2e60ece5)"/>
    </g>
    <rect x="316.54" y="129.07" width="89.42" height="72.67" fill="#f2f2f2"/>
    <rect x="316.54" y="129.07" width="89.42" height="16.21" fill="#4b5563"/>
    <rect x="316.54" y="129.07" width="89.42" height="16.21" opacity="0.1"/>
    <rect x="323.67" y="151.16" width="75.17" height="9.44" fill="#e0e0e0"/>
    <rect x="323.67" y="167.72" width="54.86" height="3.21" fill="#e0e0e0"/>
    <rect x="323.67" y="173.24" width="35.62" height="3.21" fill="#e0e0e0"/>
    <rect x="323.67" y="178.76" width="47.02" height="3.21" fill="#e0e0e0"/>
    <rect x="323.67" y="184.29" width="54.86" height="3.21" fill="#e0e0e0"/>
    <rect x="323.67" y="189.81" width="18.35" height="3.21" fill="#e0e0e0"/>
    <g opacity="0.5">
      <rect x="450.33" y="184.22" width="113.7" height="93.39" fill="url(#4adf524d-df88-48e8-970a-1ad7028c73c0)"/>
    </g>
    <rect x="451.66" y="185.98" width="110.83" height="90.08" fill="#fff"/>
    <rect x="451.66" y="185.98" width="110.83" height="20.09" fill="#4b5563"/>
    <rect x="460.49" y="213.36" width="93.17" height="11.7" fill="#f5f5f5"/>
    <rect x="460.49" y="233.89" width="68" height="3.97" fill="#e0e0e0"/>
    <rect x="460.49" y="240.74" width="44.16" height="3.97" fill="#e0e0e0"/>
    <rect x="460.49" y="247.58" width="58.28" height="3.97" fill="#e0e0e0"/>
    <rect x="460.49" y="254.43" width="68" height="3.97" fill="#e0e0e0"/>
    <rect x="460.49" y="261.27" width="22.74" height="3.97" fill="#e0e0e0"/>
    <rect x="465.35" y="217.33" width="26.49" height="3.53" fill="#69f0ae"/>
    <polygon points="125.69 536.18 260.17 570.11 368.26 482.13 368.26 428.09 128.2 367.76 125.69 536.18" opacity="0.1"/>
    <polygon points="610.83 536.18 476.35 570.11 368.26 482.13 368.26 428.09 608.32 367.76 610.83 536.18"
             opacity="0.1"/>
    <polygon points="128.83 363.36 5.66 465.16 245.71 525.49 368.88 427.46 128.83 363.36" fill="#535461"/>
    <polygon points="608.94 363.36 733.37 465.16 494.57 525.49 368.88 427.46 608.94 363.36" fill="#535461"/>
    <polygon points="608.94 363.36 733.37 465.16 494.57 525.49 368.88 427.46 608.94 363.36" opacity="0.07"/>
  </svg>
</template>
<script>
  export default {}
</script>
<style>
</style>
